<template>
  <div class="limiter">
    <div class="image">
      <img src="../assets/logo/logo.png" alt="Logo">
    </div>
    <div class="container-login100">
      <div class="wrap-login100">
        <form class="login100-form validate-form" @submit.prevent="submit">

          <h1>
            <span class="login100-form-title">
              Courier Registration
            </span>
          </h1>

          <div class="form-group">
            <label for="supplier">Select Supplier</label>
            <v-select
                id="supplier"
                v-model="form.supplier"
                :reduce="item => item.SuppCode"
                label="SupplierName"
                :options="suggestions"
                @search="fetchSuppliers"
                placeholder="Enter supplier"
            >
              <template slot="no-options">
                <b>Type to search ...</b>
              </template>
            </v-select>
          </div>

          <div class="form-group">
            <label for="pin">Pin</label>
            <input id="pin" v-model="form.pin" class="input100" type="text" placeholder="Pin" required>
          </div>

          <div class="form-group">
            <label>Units/Weighed</label>
            <div class="radio-group">
              <label>
                <input type="radio" v-model="form.units" value="units" required>
                Units
              </label>
              <label>
                <input type="radio" v-model="form.units" value="weighed" required>
                Weighed
              </label>
              <label>
                <input type="radio" v-model="form.units" value="custom" required>
                Custom
              </label>
            </div>
          </div>

          <div class="form-group" v-if="form.units !== `custom`">
            <label for="price">Price</label>
            <input id="price" v-model.number="form.price" class="input100" step="0.01" type="number" placeholder="Enter Price" required>
          </div>

          <button type="submit" class="login100-form-btn">
            Submit
          </button>

        </form>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
  name: 'CourierRegistration',
  data() {
    return {
      form: {
        supplier: '',
        pin: '',
        units: '',
        price: ''
      },
      suggestions: []
    };
  },
  components: {
    vSelect
  },
  methods: {
    fetchSuppliers (search) {
      const payload = {
        SupplierName: search,
        tpin: '',
        contact: '',
        Limit: 150
      }
      this.$store.commit('setLoadingState',true)
      return this.$store.dispatch('fetchSuppliers',payload)
          .then((data) => this.suggestions = data)
          .finally(()=> this.$store.commit('setLoadingState',false))
    },

    async submit() {
      if (!this.validateForm()) {
        responses.showInfo('Please fill out the form correctly.')
        return;
      }

      if(!this.form.price){
        this.form.price = 0;
      }

      const payload = {
        supplierID: this.form.supplier,
        pin: this.form.pin,
        priceType: this.form.units,
        price: this.form.price,
      };

      this.$store.commit('setLoadingState', true);
      return this.$store.dispatch('registration',payload)
          .then(()=> {
            responses.showSuccess('Your information has been submitted!')
            this.resetForm();
          })
          .finally(()=> this.$store.commit('setLoadingState', false))
    },

    validateForm() {
      return (
          this.form.supplier &&
          this.form.pin &&
          this.form.units
      );
    },

    resetForm() {
      this.form = {
        supplier: '',
        pin: '',
        units: '',
        price: ''
      };
    }
  }
}
</script>

